<template>
	<section v-if="isShow" class="modal showing j-popup j-omya-popup">
		<div class="modal__card" style="width:610px;">
			<div class="modal__image-holder">
				<img src="../../../static/images/maraphones/omya_1.jpg" width="100%" alt="" %>
			</div>
			<div class="modal__main">
				<p class="modal__text modal__text--large bold-font">Уважаемые коллеги!</p>
				<p class="modal__text">
					Omya и&nbsp;Эдюсон приглашают вас на&nbsp;образовательный
					марафон&nbsp;<span style="color: #58298b;font-weight: 700;">&laquo;Выше к&nbsp;звёздам!&raquo;</span>,
					который продлится с&nbsp;29&nbsp;июня по&nbsp;26&nbsp;июля 2026&nbsp;года.
				</p>
				<p class="modal__text">
					В&nbsp;рамках марафона вам предстоит отправиться
					в&nbsp;космическое путешествие и&nbsp;исследовать разные уголки звёздной системы Эдюсон, чтобы найти
					пропавшего космонавта!
				</p>
				<p class="modal__text">
					Найдите координаты необходимых курсов, пройдите их, чтобы развить профессиональные навыки,
					и&nbsp;помогите космонавту вернуться на&nbsp;орбиту!
				</p>
				<p class="modal__text">
					Больше деталей вы&nbsp;узнаете в&nbsp;
					<a
						href="https://downloads.eduson.tv/materials/files/000/010/965/original/Регламент_марафона_Omya_(29.06.26).pdf"
						class="link-btn link-btn--underline bold-font"
						style="color: #58298b;"
						target="_blank" rel="noopener noreferrer"
					>
						правилах марафона.
					</a>
				</p>
				<p class="modal__text">Желаем успехов в&nbsp;обучении!</p>
			</div>
			<div class="text-center" style="background-color: #1a1734;border-radius: 0 0 5px 5px;padding: 25px;">
				<button
					@click="showSecondPopup"
					class="regular-btn red-white-btn bold-font j-open-omya-popup"
					type="button"
				>Участвую!</button>
				<div class="mt-10 small-font-size text-center" style="color: white;">
					Участвуя, вы соглашаетесь <br>
					с
					<a class="bold-font link-btn link-btn--white link-btn--underline"
						href="https://downloads.eduson.tv/materials/files/000/010/965/original/Регламент_марафона_Omya_(29.06.26).pdf" target="_blank" rel="noopener noreferrer">
						правилами
					</a>
            	</div>
			</div>
		</div>
	</section>
</template>

<script>
export default {
	name: 'OmyaPopup',

	props: {
		upd_additional_info_path: ''
	},

	mounted() {
		setTimeout(() => {
			show_popup('.j-omya-popup');
		}, 1000)
	},

	data() {
		return {
			isShow: true
		}
	},

	methods: {
		showSecondPopup() {
			this.isShow = !this.isShow;
			show_popup('.j-omya-popup-2');
		}
	},
}
</script>
